import { home } from "./en/home";
import { login } from "./en/login";
import { module } from "./en/module";
import { help,help2 } from "./en/help";
import { common } from "./en/common";
export default {
  lang: "CN",
  home: home,
  login: login,
  module: module,
  help: help,
  help2: help2,
  common: common,
};
